module.exports = __webpack_public_path__ + "static/media/nlauncher-logo-144dpi-317w.1d865575.png";